import React from "react";

interface IProps {
  height?: number;
  width?: number;
  color?: string;
}

export const ReceiptSVG: React.FC<IProps> = ({ width, height, color = '#000000'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2"
       strokeLinecap="round" strokeLinejoin="round" height={height} width={width}>
    <path d="M20 2v20l-4-2-4 2-4-2-4 2V2z"/>
    <path d="M8 6h8"/>
    <path d="M8 10h8"/>
    <path d="M8 14h6"/>
  </svg>
);
